var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ArrowCircleDown component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconArrowCircleDown extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.2998 11.8998C21.2998 17.0898 17.0898 21.2998 11.8998 21.2998C6.7098 21.2998 2.4998 17.0898 2.4998 11.8998C2.4998 6.70981 6.7098 2.49981 11.8998 2.49981C17.0898 2.49981 21.2998 6.71981 21.2998 11.8998ZM11.8998 22.7998C17.9198 22.7998 22.7998 17.9198 22.7998 11.8998C22.7998 5.87981 17.9198 0.999806 11.8998 0.999806C5.8798 0.999807 0.999804 5.87981 0.999804 11.8998C0.999805 17.9198 5.8898 22.7998 11.8998 22.7998ZM12.3498 17.1898C12.3498 17.1898 12.4098 17.1398 12.4398 17.1098L14.7698 14.7798C15.0598 14.4898 15.0598 14.0098 14.7698 13.7198C14.4798 13.4298 13.9998 13.4298 13.7098 13.7198L12.6498 14.7798L12.6498 7.22981C12.6498 6.81981 12.3098 6.47981 11.8998 6.47981C11.4898 6.47981 11.1498 6.81981 11.1498 7.22981L11.1498 14.7798L10.0898 13.7198C9.7998 13.4298 9.3198 13.4298 9.0298 13.7198C8.7398 14.0098 8.7398 14.4898 9.0298 14.7798L11.3698 17.1198C11.4498 17.1998 11.5498 17.2598 11.6498 17.2998C11.7298 17.3298 11.8098 17.3398 11.8998 17.3398C12.0198 17.3398 12.1398 17.3098 12.2398 17.2598C12.2798 17.2398 12.3098 17.2198 12.3498 17.1898V17.1898Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconArrowCircleDown.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowCircleDown.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowCircleDown.prototype, "size", void 0);
if (customElements.get('cat-icon-arrow-circle-down') === undefined) {
    customElements.define('cat-icon-arrow-circle-down', BlocksIconArrowCircleDown);
}
